/** Pure helpers for first-run set-up (pages/onboarding.tsx). */

export const slugify = (s: string) =>
  s.toLowerCase().normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 40) || "workspace";

/** Email domains that say nothing about where someone works. */
const PERSONAL_DOMAINS = /^(gmail|googlemail|outlook|hotmail|live|msn|icloud|me|mac|yahoo|ymail|aol|proton|protonmail|pm|gmx|mail|zoho|fastmail|hey)\./;

/** A work email's domain ("ada@quillmere.example" → "quillmere.example"), or null for a personal one. */
export function workDomain(email: string | undefined): string | null {
  const domain = email?.split("@")[1]?.toLowerCase();
  return domain && !PERSONAL_DOMAINS.test(domain) ? domain : null;
}

/** A first guess at the workspace's name: the company from a work email, else "Ada's workspace". */
export function suggestWorkspaceName(email: string | undefined, name: string | undefined): string {
  const domain = workDomain(email);
  const label = domain?.split(".")[0];
  if (label) return label.split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
  const first = name?.trim().split(/\s+/)[0];
  return first ? `${first}'s workspace` : "";
}

/** The allowed-domains field as a list: commas or spaces, scheme and path dropped. */
export const parseDomains = (s: string) =>
  s
    .split(/[\s,]+/)
    .map((d) => d.trim().toLowerCase().replace(/^https?:\/\//, "").replace(/\/.*$/, ""))
    .filter(Boolean);
